import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import pluralize from 'pluralize';
import './ExchangeFromSummary.scss';

import {
  getExchangeFromUnit,
  getExchangeFromSummaryFundList,
} from '../../../redux/modules/exchangeTransaction/exchangeTransaction.selectors';
import { moduleActions } from '../../../redux/modules/index';
import StepCollapsed from '../../Shared/StepCollapsed/StepCollapsed';
import { getExchangeTotals } from '../../../utils/funds/funds-utility';

const ExchangeFromSummary = ({
  actions: { setProgress },
  exchangeFromSummaryFundList,
}) => (
  <StepCollapsed>
    {getExchangeTotals(exchangeFromSummaryFundList)} from{' '}
    {pluralize('investment', exchangeFromSummaryFundList.length, true)}
    <a
      id="exchange-step-1-edit"
      className="college-branded-link exchange-from-summary-link"
      onClick={() => setProgress(1)}
    >
      Edit
    </a>
  </StepCollapsed>
);

const mapStateToProps = (state) => {
  return {
    exchangeFromSummaryFundList: getExchangeFromSummaryFundList(state),
    exchangeFromUnit: getExchangeFromUnit(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ExchangeFromSummary
);
